export const GENERAL_SETTINGS_LIST_KEY = "GENERAL_SETTINGS_LIST";
export const GENERAL_SETTINGS_ONE_KEY = "GENERAL_SETTINGS_ONE_KEY";


export const SETTINGS_PUBLIC_KEY = "SETTINGS_PUBLIC_KEY"; // current public
export const SETTINGS_KEY = "SETTINGS_KEY"; //current
export const SPACE_SETTINGS_KEY = "SPACE_SETTINGS_KEY";
